"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sessionLabel = exports.roundToClosest = exports.countFormat = exports.convertToLocalDate = exports.getCountDownString = exports.freeCreditAmount = exports.awsImage = exports.distanceFormatting = exports.errorMessage = exports.currencyFormat = exports.monthYear = exports.dayMonthYear = exports.dayOfMonthShort = exports.dayOfMonth = exports.dayAndTimeLong = exports.dayOfWeek = exports.timeOfBooking = void 0;
var moment_1 = __importDefault(require("moment"));
var lodash_1 = require("lodash");
var functions_1 = require("./functions");
var timeOfBooking = function (time) {
    var formattedTime = (0, moment_1.default)(time, 'HH:mm:ss').format('h:mma');
    if (formattedTime.toLowerCase() === 'invalid date') {
        return 'Sold';
    }
    return formattedTime;
};
exports.timeOfBooking = timeOfBooking;
var dayOfWeek = function (date) { return (0, moment_1.default)(date).format('ddd'); };
exports.dayOfWeek = dayOfWeek;
var dayAndTimeLong = function (date, time) {
    return (0, moment_1.default)(date).format('D MMM') + " at " + timeOfBooking(time);
};
exports.dayAndTimeLong = dayAndTimeLong;
var dayOfMonth = function (date) { return "" + (0, moment_1.default)(date).format('D MMM'); };
exports.dayOfMonth = dayOfMonth;
var dayOfMonthShort = function (date) { return "" + (0, moment_1.default)(date).format('D'); };
exports.dayOfMonthShort = dayOfMonthShort;
// 15 Aug 2018
var dayMonthYear = function (date) {
    return "" + (0, moment_1.default)(date).format('D MMM Y');
};
exports.dayMonthYear = dayMonthYear;
// August 2018
var monthYear = function (date) { return "" + (0, moment_1.default)(date).format('MMMM Y'); };
exports.monthYear = monthYear;
// unfortunately statically defined for now, see @currentFormat below
var currencySymbolHelper = function (currency) {
    switch (currency) {
        case 'GBP':
            return '£';
        case 'IDR':
            return 'Rp';
        case 'EUR':
            return '€';
        case 'ZAR':
            return 'R';
        case 'SGD':
            return '$';
        case 'INR':
            return '₹';
        case 'PHP':
            return '₱';
        case 'AED':
            return 'AED';
        case 'KYD':
            return '$';
        default:
            return '$';
    }
};
/**
 * Rounds down to closest number
 * @param num
 * @param closest
 * @returns {number}
 */
var roundToClosest = function (num, closest) {
    if (closest === void 0) { closest = 1000; }
    return Math.floor(num / closest) * closest;
};
exports.roundToClosest = roundToClosest;
/**
 * converts to deliminated number
 * @param num
 * @param delimiter
 * @returns {string}
 */
var countFormat = function (num, delimiter) {
    if (delimiter === void 0) { delimiter = ','; }
    var n = String(num);
    var p = n.indexOf('.');
    return n.replace(/\d(?=(?:\d{3})+(?:\.|$))/g, function (m, i) {
        return p < 0 || i < p ? "" + m + delimiter : m;
    });
};
exports.countFormat = countFormat;
var currencyFormat = function (price, currency, siteConfig, displayDecimal, includePrefix) {
    if (currency === void 0) { currency = ''; }
    if (siteConfig === void 0) { siteConfig = null; }
    if (displayDecimal === void 0) { displayDecimal = false; }
    if (includePrefix === void 0) { includePrefix = false; }
    var priceRounded = parseFloat("" + Math.round(price * 100) / 100);
    var priceHasCents = priceRounded % 1 !== 0;
    // let formattedPrice = priceRounded.toFixed(priceHasCents || displayDecimal ? 2 : 0);
    var symbol = currencySymbolHelper(currency);
    var prefix = includePrefix && symbol !== currency ? currency + " " : '';
    var IDR = currency === 'IDR';
    var formattedPrice = priceRounded.toFixed(priceHasCents || (displayDecimal && !IDR) ? 2 : 0);
    // in the case that a page can't access the static
    // query below (cos it's dynamic), like confirmation pages
    if (IDR) {
        return symbol + " " + formattedPrice / 1000 + "K";
    }
    if (currency.length > 0) {
        return "" + prefix + symbol + countFormat(formattedPrice);
    }
    return "" + siteConfig.currencySymbol + countFormat(formattedPrice);
};
exports.currencyFormat = currencyFormat;
// eslint-disable-next-line max-len
var freeCreditAmount = function (siteConfig, displayDecimal) {
    if (displayDecimal === void 0) { displayDecimal = false; }
    return currencyFormat(siteConfig.freeCreditAmount, siteConfig.currency, null, displayDecimal);
};
exports.freeCreditAmount = freeCreditAmount;
var errorMessage = function (error, fallbackMessage) {
    if (error === undefined) {
        return 'Undefined error';
    }
    if (error instanceof String) {
        return error.toString();
    }
    if (error.graphQLErrors && error.graphQLErrors.length) {
        return error.graphQLErrors[0].message;
    }
    if (error.message && error.message.length) {
        return error.message;
    }
    return fallbackMessage || 'There was an error';
};
exports.errorMessage = errorMessage;
// countFormat(roundToClosest(siteConfig.dinerCount, 10000))
var distanceFormatting = function (distance) {
    if (Number.isNaN(distance) || distance === undefined) {
        return false;
    }
    var finalDistance = Number(Math.round(distance * 10) / 10).toFixed(1);
    return countFormat(finalDistance) + " km";
};
exports.distanceFormatting = distanceFormatting;
/**
 * Takes uri and formats image url
 * @param uri
 * @param width
 * @param height
 * @returns {string}
 */
var awsImage = function (uri, width, height) {
    var IMAGE_DOMAIN = process.env.GATSBY_IMAGE_DOMAIN || 'https://images.firsttable.net/';
    var dimensions = width && height ? width + "x" + height : '';
    return ("" + IMAGE_DOMAIN + dimensions + "/" + uri).replace(/([^:])(\/\/+)/g, '$1/');
};
exports.awsImage = awsImage;
var getCountDownString = function (time) {
    var cutOffLocalTime = moment_1.default.utc(time).local();
    var now = (0, moment_1.default)();
    var duration = moment_1.default.duration(cutOffLocalTime.diff(now));
    if (!(0, lodash_1.isEmpty)(duration)) {
        var hours = duration.hours();
        var minutes = duration.minutes();
        var times = [];
        if (hours === 1) {
            times.push(hours + " hour");
        }
        if (hours > 1) {
            times.push(hours + " hours");
        }
        if (minutes === 1) {
            times.push(minutes + " minute");
        }
        if (minutes > 1) {
            times.push(minutes + " minutes");
        }
        if (times.length > 0) {
            return "Quick, only " + times.join(', ') + " left to book this table! Cut off time is " + cutOffLocalTime.format('h:mma') + ".";
        }
        return "Time is running out to book this table! Cut off time is " + cutOffLocalTime.format('h:mma') + ".";
    }
    return false;
};
exports.getCountDownString = getCountDownString;
var convertToLocalDate = function (date) { return moment_1.default.utc(date).local(); };
exports.convertToLocalDate = convertToLocalDate;
/**
 * Public facing readable display of our sessions
 * @param session
 */
var sessionLabel = function (session) {
    return session.toLowerCase() === 'dinner2' ? 'Last Table' : (0, functions_1.capitalise)(session);
};
exports.sessionLabel = sessionLabel;
